<template>
  <div>
    <Form ref="employee" :model="employee" :rules="employeeRule" :label-width="120">
      <FormItem label="人员姓名：" prop="employeeName">
        <Input v-model="employee.employeeName" placeholder="请输入人员名称" />
      </FormItem>
      <FormItem label="手机号：" prop="employeePhoneNum">
        <Row>
          <Col span="18">
            <Input
              v-model="employee.employeePhoneNum"
              placeholder="请输入手机号"
              :disabled="employee.id ? true : false"
            />
          </Col>
          <Col span="4" offset="2">
            <Checkbox v-model="employee.phoneNumIsSecret">&nbsp;是否保密</Checkbox>
          </Col>
        </Row>
      </FormItem>
      <FormItem label="性别：" prop="employeeSex">
        <RadioGroup v-model="employee.employeeSex" @on-change="changeGender">
          <Radio v-for="(item,index) in this.gender" :key="index" :label="item.id">
            <span>{{item.itemName}}</span>
          </Radio>
        </RadioGroup>
      </FormItem>
      <!-- 选择部门 -->
      <FormItem label="选择部门：">
        <selectOrganize-com
          :selectedDepartment="employee.departments"
          @byDepartments="getDepartments"
        ></selectOrganize-com>
      </FormItem>

      <!-- 考勤著部门 -->
      <FormItem label="选择考勤主部门：" v-show="employee.departments.length > 1">
        <el-select v-model="employee.attendanceDepartmentId" placeholder="请选择考勤著部门">
          <el-option
            v-for="item in employee.departments"
            :key="item.id"
            :label="item.departmentName"
            :value="item.id"
          ></el-option>
        </el-select>
      </FormItem>

      <FormItem label="邮箱：">
        <Input v-model="employee.employeeEmail" placeholder="请输入邮箱" />
      </FormItem>
      <FormItem label="工号：">
        <Input v-model="employee.employeeNumber" placeholder="请输入工号" />
      </FormItem>
      <!--   选择角色   -->
      <FormItem label="角色：">
        <selectRole-com
          @byRoles="getRoles"
          @byRolesAdd="getRolesAdd"
          @byRolesDelete="getRolesDelete"
          :defaultVal="employee.startRoles"
        ></selectRole-com>
        <Input v-model="employee.rolesShow" v-show="false" />
      </FormItem>
      <FormItem label="入职时间：">
        <DatePicker
          v-model="entryTime"
          format="yyyy-MM-dd"
          type="date"
          :editable="false"
          style="width: 215px;"
        ></DatePicker>
      </FormItem>
      <FormItem label="参加工作时间：">
        <DatePicker
          v-model="joinWorkTime"
          format="yyyy-MM-dd"
          type="date"
          :editable="false"
          style="width: 215px;"
        ></DatePicker>
      </FormItem>
      <FormItem label="职位：">
        <Input v-model="employee.post" placeholder="请输入职位" />
      </FormItem>
      <FormItem label="身份证号：">
        <Input v-model="employee.idNumber" placeholder="请输入身份证号码" />
      </FormItem>
      <FormItem label="住址：">
        <Input v-model="employee.address" placeholder="请输入住址" />
      </FormItem>
      <FormItem label="紧急联系人：">
        <Input v-model="employee.emergencyContact" placeholder="请输入紧急联系人" />
      </FormItem>
      <FormItem label="联系人电话：">
        <Input v-model="employee.emergencyPhoneNum" placeholder="请输入紧急联系人电话" />
      </FormItem>
      <FormItem label="备注：">
        <Input v-model="employee.remark" type="textarea" :autosize="{minRows: 2,maxRows: 5}" />
      </FormItem>
    </Form>
    <div class="demo-drawer-footer">
      <Button style="margin-right: 8px" @click="handleEsc()">取消</Button>
      <Button type="primary" @click="handleSubmit()">确定</Button>
    </div>
  </div>
</template>
<script>
import selectRole from "@/components/business/selectRole.vue";
import selectOrganize from "@/components/business/selectDepartment/mutiSelectDepartments.vue";
import Vuex from "vuex";
export default {
  components: {
    "selectOrganize-com": selectOrganize,
    "selectRole-com": selectRole
  },

  computed: {
    ...Vuex.mapState({
      //正则
      employeeRule: state => state.verify.employeeFrom
    })
  },

  props: ["employeeInfo"],

  mounted() {
    // this.forGender();
  },

  watch: {
    employeeInfo: {
      handler(val) {
        this.employee = JSON.parse(JSON.stringify(val));
        if(!val.joinWorkTime) {
          return this.joinWorkTime = ''
        } else {
          this.joinWorkTime = new Date(val.joinWorkTime)
        }
        if(!val.entryTime) {
          return this.entryTime = ''
        } else {
          this.entryTime = new Date(val.entryTime)
        }
      },
      deep: true
    },

    "employee.departments": {
      handler(newVal, oldVal) {
        var toggle = this.employee.departments.some(item => {
          return this.employee.attendanceDepartmentId == item.id;
        });
        if (!toggle) {
          this.employee.attendanceDepartmentId = this.employee.departments.length
          ? this.employee.departments[0].id
          : "";
        }
      },
      deep: true
    },
  },

  data() {
    return {
      employee: this.employeeInfo,
      selectedDepartments: [],
      gender: [
        {
          id: "18001",
          enterpriseId: "0",
          itemName: "男",
          itemCode: "man",
          enumTypeId: "10008",
        },
        {
          id: "18002",
          enterpriseId: "0",
          itemName: "女",
          itemCode: "woman",
          enumTypeId: "10008",
        }
      ],
      //默认为空
      joinWorkTime: '',
      entryTime: ''
    };
  },

  methods: {
    //获取部门的add,delete
    getDepartmentAddDelete() {
      var adds = this.$js.arrMinusPlus(
        this.employee.departments,
        this.employeeInfo.departments,
        "id"
      );
      var deletes = this.$js.arrMinusPlus(
        this.employeeInfo.departments,
        this.employee.departments,
        "id"
      );
      //筛选出来原存在的，但主管发生变化的部门
      var managerChengedList = [];
      this.employee.departments.forEach(item => {
        var managerChenged = this.employeeInfo.departments.some((el) => {
          return el.id == item.id && el.isDepartmentManager != item.isDepartmentManager
        })
        managerChengedList.push({
          departmentId: item.id,
          isDepartmentManager:item.isDepartmentManager
        })
      })
      //将部门id字段转为departmentId
      adds = adds.map((item) => {
        return {
          departmentId: item.id,
          isDepartmentManager:item.isDepartmentManager
        }
      }).concat(managerChengedList)
      deletes = deletes.map((item) => {
        return {
          departmentId: item.id,
          isDepartmentManager:item.isDepartmentManager
        }
      });
      this.employee.departmentsAddAndDelete.adds = adds;
      this.employee.departmentsAddAndDelete.deletes = deletes;
    },

    getDepartments(val) {
      this.employee.departments = val;
    },

    forGender() {
      this.$api.enumTypeCode("sex").then(res => {
        this.gender = res;
      });
    },

    changeGender(val) {
      this.employee.sexEnumItemId = val;
    },

    getRoles(val) {
      if (val.length) {
        this.employee.rolesShow = "show";
      } else {
        this.employee.rolesShow = "";
      }
    },

    getRolesAdd(val) {
      this.employee.roleIds.adds = val;
    },

    getRolesDelete(val) {
      this.employee.roleIds.deletes = val;
    },

    getCommon(info) {
      this.$Message.success(info);
      this.$emit("closed-modify-employee-drawer");
      this.$emit("reset-employees-table");
      this.cleanDepartments();
    },

    handleSubmit() {
      this.$refs["employee"].validate(valid => {
        if (!valid) {
          return this.$Message.error("请填写完整所需要的信息");
        }
        if(!this.judgeSelectDepartments()){
          return this.$Message.error("请至少选择一个部门");
        }
        this.getDepartmentAddDelete();
        this.handleRequestData();
        this.handleJudges(this.employee.type);
      });
    },

    handleRequestData() {
      if(this.joinWorkTime) {
        this.employee.joinWorkTime = this.$js.dateTimeUtils(this.joinWorkTime).date;
      } else {
        this.employee.joinWorkTime = '';
      }
      if(this.entryTime) {
        this.employee.entryTime = this.$js.dateTimeUtils(this.entryTime).date;
      } else {
        this.employee.entryTime = '';
      }
    },

    //判断是否选择部门
    judgeSelectDepartments(){
      if(!this.employee.departments || !this.employee.departments.length){
        return false;
      }
      return true
    },

    handleJudges(type) {
      switch (type) {
        case "invite":
          this.$api.agree(this.employee).then(() => {
            this.getCommon("申请加入成功");
          });
          break;

        case "edit":
          this.$api.editEmployee(this.employee).then(() => {
            this.getCommon("修改成功");
          });
          break;

        case "add":
          this.$api.addEmployee(this.employee).then(() => {
            this.getCommon("添加成功");
          });
          break;
      }
    },

    handleEsc() {
      this.$emit("closed-modify-employee-drawer");
      this.$refs["employee"].resetFields();
      this.cleanDepartments();
      this.entryTime = '';
      this.joinWorkTime = '';
    },

    //清空部门数据
    cleanDepartments() {
      this.employee.departments = [];
    }
  }
};
</script>
<style scoped>
.demo-drawer-footer {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}

.header {
  color: #464c5b;
  text-align: center;
  font-size: 16px;
}

.content {
  height: 300px;
  overflow: auto;
}

.backfill {
  width: 100%;
  border: 1px solid #e4e4e4;
  /* cursor: pointer; */
}

.backfill .fillbox {
  display: inline-block;
  color: #38adff;
  background: #daeefd;
  padding: 0 10px;
  border-radius: 4px;
  margin: 4px;
}

.fillbox {
  position: relative;
}

.erricon {
  position: absolute;
  top: -3px;
  right: -5px;
  color: red;
}
</style>
